/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkMessageAttachmentDto } from '../models/work-message-attachment-dto';
import { WorkMessagingOptionsDto } from '../models/work-messaging-options-dto';
import { WorkMessagingTemplate } from '../models/work-messaging-template';
import { WorkMessagingTemplateDto } from '../models/work-messaging-template-dto';
import { WorkMessagingTemplateNameEnum } from '../models/work-messaging-template-name-enum';
import { WorkPreparedMessageAttachmentDto } from '../models/work-prepared-message-attachment-dto';
import { WorkProjectAppointmentDatesOverviewMessageOptionsDto } from '../models/work-project-appointment-dates-overview-message-options-dto';
import { WorkSendMessageDto } from '../models/work-send-message-dto';
import { WorkSuccessDto } from '../models/work-success-dto';

@Injectable({ providedIn: 'root' })
export class WorkMessagingV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `messagingV2ControllerGetAllMessagingTemplateDropdownOptions()` */
  static readonly MessagingV2ControllerGetAllMessagingTemplateDropdownOptionsPath = '/v2/messaging/messagingTemplate/dropdown-options';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingV2ControllerGetAllMessagingTemplateDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerGetAllMessagingTemplateDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingV2Service.MessagingV2ControllerGetAllMessagingTemplateDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingV2ControllerGetAllMessagingTemplateDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerGetAllMessagingTemplateDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.messagingV2ControllerGetAllMessagingTemplateDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `messagingV2ControllerFindMessagingTemplateById()` */
  static readonly MessagingV2ControllerFindMessagingTemplateByIdPath = '/v2/messaging/messagingTemplate/{id}';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingV2ControllerFindMessagingTemplateById()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerFindMessagingTemplateById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMessagingTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingV2Service.MessagingV2ControllerFindMessagingTemplateByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMessagingTemplate>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingV2ControllerFindMessagingTemplateById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerFindMessagingTemplateById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMessagingTemplate> {
    return this.messagingV2ControllerFindMessagingTemplateById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMessagingTemplate>): WorkMessagingTemplate => r.body)
    );
  }

  /** Path part for operation `messagingV2ControllerGetMessagingOptions()` */
  static readonly MessagingV2ControllerGetMessagingOptionsPath = '/v2/messaging/options/byContactsOrUsers';

  /**
   * Required permissions: messaging:users, messaging:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingV2ControllerGetMessagingOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerGetMessagingOptions$Response(
    params?: {
      contactIds?: Array<number>;
      userIds?: Array<number>;
      withPrivatePhones?: boolean;
      onlyMobilPhones?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkMessagingOptionsDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingV2Service.MessagingV2ControllerGetMessagingOptionsPath, 'get');
    if (params) {
      rb.query('contactIds', params.contactIds, {});
      rb.query('userIds', params.userIds, {});
      rb.query('withPrivatePhones', params.withPrivatePhones, {});
      rb.query('onlyMobilPhones', params.onlyMobilPhones, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkMessagingOptionsDto>>;
      })
    );
  }

  /**
   * Required permissions: messaging:users, messaging:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingV2ControllerGetMessagingOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerGetMessagingOptions(
    params?: {
      contactIds?: Array<number>;
      userIds?: Array<number>;
      withPrivatePhones?: boolean;
      onlyMobilPhones?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkMessagingOptionsDto>> {
    return this.messagingV2ControllerGetMessagingOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkMessagingOptionsDto>>): Array<WorkMessagingOptionsDto> => r.body)
    );
  }

  /** Path part for operation `messagingV2ControllerGetMessagingTemplate()` */
  static readonly MessagingV2ControllerGetMessagingTemplatePath = '/v2/messaging/messagingTemplate/byName/{templateName}';

  /**
   * Required permissions: messaging:users, messaging:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingV2ControllerGetMessagingTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerGetMessagingTemplate$Response(
    params: {
      templateName: WorkMessagingTemplateNameEnum;

    /**
     * Variante innerhalb der Funktion (z.B. die Mahnstufe bei der Zahlungserinnerung). Ohne passende Variante wird die generische Vorlage der Funktion geliefert.
     */
      variantKey?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMessagingTemplateDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingV2Service.MessagingV2ControllerGetMessagingTemplatePath, 'get');
    if (params) {
      rb.path('templateName', params.templateName, {});
      rb.query('variantKey', params.variantKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMessagingTemplateDto>;
      })
    );
  }

  /**
   * Required permissions: messaging:users, messaging:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingV2ControllerGetMessagingTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerGetMessagingTemplate(
    params: {
      templateName: WorkMessagingTemplateNameEnum;

    /**
     * Variante innerhalb der Funktion (z.B. die Mahnstufe bei der Zahlungserinnerung). Ohne passende Variante wird die generische Vorlage der Funktion geliefert.
     */
      variantKey?: string;
    },
    context?: HttpContext
  ): Observable<WorkMessagingTemplateDto> {
    return this.messagingV2ControllerGetMessagingTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMessagingTemplateDto>): WorkMessagingTemplateDto => r.body)
    );
  }

  /** Path part for operation `messagingV2ControllerGetProjectAppointmentDatesOverviewMessageOptions()` */
  static readonly MessagingV2ControllerGetProjectAppointmentDatesOverviewMessageOptionsPath = '/v2/messaging/projectAppointmentDatesOverviewMessageOptions/{projectId}';

  /**
   * Required permissions: messaging:users, messaging:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingV2ControllerGetProjectAppointmentDatesOverviewMessageOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerGetProjectAppointmentDatesOverviewMessageOptions$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectAppointmentDatesOverviewMessageOptionsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingV2Service.MessagingV2ControllerGetProjectAppointmentDatesOverviewMessageOptionsPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectAppointmentDatesOverviewMessageOptionsDto>;
      })
    );
  }

  /**
   * Required permissions: messaging:users, messaging:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingV2ControllerGetProjectAppointmentDatesOverviewMessageOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerGetProjectAppointmentDatesOverviewMessageOptions(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectAppointmentDatesOverviewMessageOptionsDto> {
    return this.messagingV2ControllerGetProjectAppointmentDatesOverviewMessageOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectAppointmentDatesOverviewMessageOptionsDto>): WorkProjectAppointmentDatesOverviewMessageOptionsDto => r.body)
    );
  }

  /** Path part for operation `messagingV2ControllerGetProjectAppointmentDatesOverviewConfirmationTemplate()` */
  static readonly MessagingV2ControllerGetProjectAppointmentDatesOverviewConfirmationTemplatePath = '/v2/messaging/projectAppointmentDatesOverviewConfirmationTemplate/{projectId}';

  /**
   * Required permissions: messaging:users, messaging:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingV2ControllerGetProjectAppointmentDatesOverviewConfirmationTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerGetProjectAppointmentDatesOverviewConfirmationTemplate$Response(
    params: {
      projectId: number;
      appointmentTaskIds?: Array<number>;
      montageStartAndEnd: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMessagingTemplateDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingV2Service.MessagingV2ControllerGetProjectAppointmentDatesOverviewConfirmationTemplatePath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.query('appointmentTaskIds', params.appointmentTaskIds, {});
      rb.query('montageStartAndEnd', params.montageStartAndEnd, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMessagingTemplateDto>;
      })
    );
  }

  /**
   * Required permissions: messaging:users, messaging:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingV2ControllerGetProjectAppointmentDatesOverviewConfirmationTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerGetProjectAppointmentDatesOverviewConfirmationTemplate(
    params: {
      projectId: number;
      appointmentTaskIds?: Array<number>;
      montageStartAndEnd: boolean;
    },
    context?: HttpContext
  ): Observable<WorkMessagingTemplateDto> {
    return this.messagingV2ControllerGetProjectAppointmentDatesOverviewConfirmationTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMessagingTemplateDto>): WorkMessagingTemplateDto => r.body)
    );
  }

  /** Path part for operation `messagingV2ControllerSendMessage()` */
  static readonly MessagingV2ControllerSendMessagePath = '/v2/messaging';

  /**
   * Required permissions: messaging:users, messaging:contacts, messaging:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingV2ControllerSendMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  messagingV2ControllerSendMessage$Response(
    params: {
      body: WorkSendMessageDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingV2Service.MessagingV2ControllerSendMessagePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: messaging:users, messaging:contacts, messaging:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingV2ControllerSendMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  messagingV2ControllerSendMessage(
    params: {
      body: WorkSendMessageDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.messagingV2ControllerSendMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `messagingV2ControllerPrepareAttachment()` */
  static readonly MessagingV2ControllerPrepareAttachmentPath = '/v2/messaging/attachments/prepare';

  /**
   * Required permissions: messaging:users, messaging:contacts, messaging:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingV2ControllerPrepareAttachment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  messagingV2ControllerPrepareAttachment$Response(
    params: {
      body: WorkMessageAttachmentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPreparedMessageAttachmentDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingV2Service.MessagingV2ControllerPrepareAttachmentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPreparedMessageAttachmentDto>;
      })
    );
  }

  /**
   * Required permissions: messaging:users, messaging:contacts, messaging:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingV2ControllerPrepareAttachment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  messagingV2ControllerPrepareAttachment(
    params: {
      body: WorkMessageAttachmentDto
    },
    context?: HttpContext
  ): Observable<WorkPreparedMessageAttachmentDto> {
    return this.messagingV2ControllerPrepareAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPreparedMessageAttachmentDto>): WorkPreparedMessageAttachmentDto => r.body)
    );
  }

  /** Path part for operation `messagingV2ControllerDownloadPreparedAttachment()` */
  static readonly MessagingV2ControllerDownloadPreparedAttachmentPath = '/v2/messaging/attachments/prepared/{token}';

  /**
   * Required permissions: messaging:users, messaging:contacts, messaging:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingV2ControllerDownloadPreparedAttachment()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerDownloadPreparedAttachment$Response(
    params: {
      token: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Blob>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingV2Service.MessagingV2ControllerDownloadPreparedAttachmentPath, 'get');
    if (params) {
      rb.path('token', params.token, {});
    }

    return this.http.request(
      rb.build({ responseType: 'blob', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Required permissions: messaging:users, messaging:contacts, messaging:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingV2ControllerDownloadPreparedAttachment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingV2ControllerDownloadPreparedAttachment(
    params: {
      token: string;
    },
    context?: HttpContext
  ): Observable<Blob> {
    return this.messagingV2ControllerDownloadPreparedAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
